import { useEffect } from "react";
import { isBrowser } from "../isBrowser";
export const useKeyboard = (
  code: string,
  callback?: (event: KeyboardEvent) => void,
) => {
  useEffect(() => {
    if (!isBrowser) return;
    const handler = (event: KeyboardEvent) => {
      if (callback !== undefined && event.key === code) {
        callback(event);
      }
    };
    window.addEventListener("keydown", handler);
    return () => {
      window.removeEventListener("keydown", handler);
    };
  }, [callback, code]);
};
